import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HomeHero from "@/views/home/src/HomeHero.vue";
import HomeRarity from "@/views/home/src/HomeRarity.vue";
import HomeExplore from "@/views/home/src/HomeExplorer.vue";
import HomeStory from "@/views/home/src/HomeStory.vue";
import HomeMaskOf from "@/views/home/src/HomeMaskOf.vue";
import HomeAbout from "@/views/home/src/HomeAbout.vue";
import HomeTeam from "@/views/home/src/HomeTeam.vue";
import HomeCta from "@/views/home/src/HomeCta.vue";
import HomeQuestions from "@/views/home/src/HomeFAQ.vue";
import HomeCtaAirdrop from "@/views/home/src/HomeCtaAirdrop.vue";
import HomeRoadmap from "@/views/home/src/HomeRoadmap.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HomeHero),
    _createVNode(HomeExplore),
    _createVNode(HomeStory),
    _createVNode(HomeRarity),
    _createVNode(HomeCtaAirdrop),
    _createVNode(HomeRoadmap),
    _createVNode(HomeAbout),
    _createVNode(HomeMaskOf),
    _createVNode(HomeTeam),
    _createVNode(HomeCta),
    _createVNode(HomeQuestions)
  ]))
}
}

})